import React from 'react'
import StockInItemHeader from './StockInItemHeader'
import StockInItemInner from './StockInItemInner'
import StockInItemFooter from './StockInItemFooter'
import { getStockInByID, saveStockIn, restoreStockIn, deleteStockIn } from '../StockInFunctions'

export const stockInItemControllerContext = React.createContext()

function useStockInItemController(props) {
  const stockInItem = props.stockInItem

  const obj = {
    stockInItem,
    saveStockIn,
    deleteStockIn,
    restoreStockIn,
    getStockInByID
  }

  return (obj)
}

function StockInItemController(props) {
  const stockInItemController = useStockInItemController(props)
  return (
    <React.Fragment>
      <stockInItemControllerContext.Provider value={stockInItemController}>
        <StockInItemHeader />
        <StockInItemInner />
        <StockInItemFooter />
      </stockInItemControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(StockInItemController)
